import React from 'react'
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const TurnoverDetails = (props) => {
    return (
        <>
            <div className='user-div turn-div'>
                <div className='title-box'>
                    <h3 className="text-create-message">{props.t('turnover_and_commission_details')}</h3>
                </div>
            </div>
            <div className='turn-detail-popup'>
                <div className='inbox-div'>
                    <span className='total-overall'><p>{props.t('total_overall')}</p></span>
                </div>

                {props.data && props.data.length > 0 ? (
                    props.data.map((item, index) => (
                        <div key={index} className='turn-popup-table-details'>
                            <span className='turn-cat'>
                                <p>{item.category_name}</p> 
                            </span>
                            <div className='turn-popup-table'>
                               
                                <table>
                                    <tbody className="turnover-bg">
                                        <tr>
                                            <td>
                                                <span className="data-one">{props.t("turnover")}:</span>
                                            </td>
                                        </tr>
                                        <tr className="all-data">
                                            <td>{item.total_turnover || 0}</td> 
                                        </tr>
                                    </tbody>
                                </table>

                               
                                <table>
                                    <tbody className="turnover-bg">
                                        <tr>
                                            <td>
                                                <span className="data-one">{props.t("commission")}:</span>
                                            </td>
                                        </tr>
                                        <tr className="all-data">
                                            <td>{item.total_commission || 0}</td> 
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>{props.t('no_data_available')}</p> 
                )}
            </div>
        </>
    );
}

TurnoverDetails.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(TurnoverDetails);
